import _ from 'lodash'
import { decorator as reusePromise } from 'reuse-promise'
import { jsonCloneDeep } from '../utils'
import * as errors from '../errors'
import BaseService from './BaseService'

export default class RoleTagsService extends BaseService {
  async findAll(options={}) {
    options = _.defaults(options, { ignoreNotFound: true, bypassCache: false })
    let organizations = this.host.models.Organization.getAll()
    if (organizations.length === 0) {
      organizations = await this.host.organizations.findAll()
    }
    const results = await Promise.all(organizations.map(organization =>
      this.findAllForOrganization(organization.id, options)
    ))

    return _.flatten(results)
  }

  @reusePromise()
  async findAllForOrganization(organizationId: string|Object, options={}) {
    options = _.defaults(options, { ignoreNotFound: true, bypassCache: false })
    organizationId = this._resolveModelId(organizationId)
    const organization = this._resolveEntity(organizationId)

    if (!organization.rolesEnabled || !organization.canAdminRoles) return []

    const data = await this.host.api.roleTags.findAll(organizationId)

    if (!data) {
      if (options.ignoreNotFound) return []
      throw new errors.NotFoundError('roleTags', organizationId)
    }

    const result = data.map(entry => {
      const id = `${organizationId}:${entry['tag_id']}`
      return this.host.models.RoleTag.inject({ ...entry, id, organizationId })
    })

    this.host.models.Organization.touch(organizationId)

    return result
  }

  reactToUpdateEventCR({ data }) {
    data = jsonCloneDeep(data)
    const { entity, organization_id: organizationId } = data
    const {
      color,
      display_name: name,
      token: tagId,
    } = entity

    const {
      color_id: colorId,
      color_value: colorValue,
    } = color

    const tag = this.host.models.RoleTag.inject({
      color: colorId,
      colorValue,
      id: `${organizationId}:${tagId}`,
      name,
      organizationId,
      tagId,
    })

    return tag
  }

  reactToUpdateEvent({ data }) {
    if (this.config.condensedReplays) {
      this.reactToUpdateEventCR({ data })
      return
    }
    data = jsonCloneDeep(data)
    const {
      color,
      display_name: name,
      organization_key: organizationId,
      token: tagId,
    } = data

    const {
      color_id: colorId,
      color_value: colorValue,
    } = color

    const tag = this.host.models.RoleTag.inject({
      color: colorId,
      colorValue,
      id: `${organizationId}:${tagId}`,
      name,
      organizationId,
      tagId,
    })

    return tag
  }

  getAll() { return this.host.models.RoleTag.getAll() }
  getById(id: string) { return this.host.models.RoleTag.get(id) }
}
